import {
    IS_LOADING_ACTION_AWARDS, CREATE_ACTION_AWARD, UPDATE_ACTION_AWARD, ACTION_AWARD_LIST, DELETE_ACTION_AWARD_INFO, GET_ACTION_AWARD_INFO, IS_LOADING_CHALLENGE_AWARDS,
    CREATE_CHALLENGE_AWARD, UPDATE_CHALLENGE_AWARD, CHALLENGE_AWARD_LIST, DELETE_CHALLENGE_AWARD, GET_CHALLENGE_AWARD_INFO, IS_LOADING_TYPES_OF_AWARDS, TYPES_OF_AWARDS_LIST,
    CREATE_TYPE_OF_AWARD, UPDATE_TYPE_OF_AWARDS, DELETE_TYPE_OF_AWARD, IS_LOADING_AWARDS, CREATE_AWARD, UPDATE_AWARDS, DELETE_AWARD, AWARDS_LIST, GET_AWARD_INFO,
    IS_LOADING_RANKS, RANKS_LIST, CREATE_RANK, UPDATE_RANK, DELETE_RANK, IS_ERROR_ACTION_AWARDS
} from '../actions/types'

const initialState = {
    isLoadingListActionAwards: false,
    listActionAwards: [],
    actionAwardInfo: {},
    isLoadingListChallengeAwards: false,
    listChallengeAwards: [],
    challengeAwardInfo: {},
    isLoadingListTypeOfAwards: false,
    listTypeOfAwards: [],
    isLoadingListAwards: false,
    listAwards: [],
    isLoadingListRanks: false,
    listRanks: []
}

export default function (state = initialState, action) {
    switch (action.type) {

        case IS_LOADING_ACTION_AWARDS:
            return { ...state, isLoadingListActionAwards: true }
        case IS_ERROR_ACTION_AWARDS:
            return { ...state, isLoadingListActionAwards: false }
        case CREATE_ACTION_AWARD:
            var addActionAward = Array.from(state.listActionAwards)
            addActionAward.push(action.payload)
            return { ...state, listActionAwards: addActionAward, isLoadingListActionAwards: false }
        case UPDATE_ACTION_AWARD:
            var editActionAward = Array.fromstate.listActionAwards
            editActionAward[action.payload.index] = action.payload.actionAward
            return { ...state, listActionAwards: editActionAward, isLoadingListActionAwards: false }
        case ACTION_AWARD_LIST:
            return { ...state, listActionAwards: action.payload, isLoadingListActionAwards: false }
        case DELETE_ACTION_AWARD_INFO:
            var deleteActionAward = Array.from(state.listActionAwards)
            deleteActionAward.splice(action.payload, 1)
            return { ...state, isLoadingListActionAwards: false, listActionAwards: deleteActionAward }
        case GET_ACTION_AWARD_INFO:
            return { ...state, actionAwardInfo: action.payload }


        case IS_LOADING_CHALLENGE_AWARDS:
            return { ...state, isLoadingListChallengeAwards: true }
        case CREATE_CHALLENGE_AWARD:
            var addChallengeAward = Array.from(state.listChallengeAwards)
            addChallengeAward.push(action.payload)
            return { ...state, listChallengeAwards: addChallengeAward, isLoadingListChallengeAwards: false }
        case UPDATE_CHALLENGE_AWARD:
            var editChallengeAward = state.listChallengeAwards
            editChallengeAward[action.payload.index] = action.payload.challengeAward
            return { ...state, listChallengeAwards: editChallengeAward, isLoadingListChallengeAwards: false }
        case CHALLENGE_AWARD_LIST:
            return { ...state, listChallengeAwards: action.payload || [], isLoadingListChallengeAwards: false }
        case DELETE_CHALLENGE_AWARD:
            var deleteChallengeAward = state.listChallengeAwards
            deleteChallengeAward.splice(action.payload, 1)
            return { ...state, isLoadingListChallengeAwards: false, listChallengeAwards: deleteChallengeAward }
        case GET_CHALLENGE_AWARD_INFO:
            return { ...state, challengeAwardInfo: action.payload }


        case IS_LOADING_TYPES_OF_AWARDS:
            return { ...state, isLoadingListTypeOfAwards: true }
        case TYPES_OF_AWARDS_LIST:
            return { ...state, listTypeOfAwards: action.payload, isLoadingListTypeOfAwards: false }
        case CREATE_TYPE_OF_AWARD:
            var addTypeOfAward = state.listTypeOfAwards
            addTypeOfAward.push(action.payload)
            return { ...state, listTypeOfAwards: addTypeOfAward, isLoadingListTypeOfAwards: false }
        case UPDATE_TYPE_OF_AWARDS:
            var editTypeOfAward = state.listTypeOfAwards
            editTypeOfAward[action.payload.index] = action.payload.typeOfAward
            return { ...state, listTypeOfAwards: editTypeOfAward, isLoadingListTypeOfAwards: false }
        case DELETE_TYPE_OF_AWARD:
            var deleteTypeOfAward = state.listTypeOfAwards
            deleteTypeOfAward.splice(action.payload, 1)
            return { ...state, isLoadingListTypeOfAwards: false, listTypeOfAwards: deleteTypeOfAward }


        case IS_LOADING_AWARDS:
            return { ...state, isLoadingListAwards: true }
        case AWARDS_LIST:
            return { ...state, listAwards: action.payload, isLoadingListAwards: false }
        case CREATE_AWARD:
            console.log()
            var addAward = state.listAwards
            addAward.push(action.payload)
            return { ...state, listAwards: addAward, isLoadingListAwards: false }
        case UPDATE_AWARDS:
            var editAward = state.listAwards
            editAward[action.payload.index] = action.payload.awardEdited
            return { ...state, listAwards: editAward, isLoadingListAwards: false }
        case DELETE_AWARD:
            var deleteAward = state.listAwards
            deleteAward.splice(action.payload, 1)
            return { ...state, isLoadingListAwards: false, listAwards: deleteAward }

        case IS_LOADING_RANKS:
            return { ...state, isLoadingListRanks: true }
        case RANKS_LIST:
            return { ...state, listRanks: action.payload || [], isLoadingListRanks: false }
        case CREATE_RANK:
            console.log()
            var addRank = state.listRanks
            addRank.push(action.payload)
            return { ...state, listRanks: addRank, isLoadingListRanks: false }
        case UPDATE_RANK:
            var editRank = state.listRanks.map(rank => {
                if (rank._id === action.payload.id) {
                    rank = action.payload.rankEdited
                }
                return rank
            })

            return { ...state, listRanks: editRank, isLoadingListRanks: false }
        case DELETE_RANK:
            var deleteRank = state.listRanks
            deleteRank.splice(action.payload, 1)
            return { ...state, isLoadingListRanks: false, listRanks: deleteRank }

        default:
            return state

    }
}